export enum okCancelDialogEnum {
  information,
  warning,
  success,
  error,
}

export class OkCancelDialogData {
  content: string;
  title: string;
  oklabel: string;
  cancellabel: string;
  dlgType?: okCancelDialogEnum;
}
